import React from 'react';
import classes from './Navigation.css';
import { NavLink } from 'react-router-dom';

const navigation = (props) => {
    let registrationNav = null;
    let planInformationNav = null;
    let planCompareNav = null;
    let instreamNav = null;
    let disclaimerNav = null;
    let methodologyNav = null;
    let glossaryNav = null;
    let ratesNav = null;
    let productsNav = null;
    let introductionNav = null;
    let backToIntroductionButton = null
    let showNavigation = false;

    if (props.showRegistration) {
        showNavigation = true;
        registrationNav = (
            <li className="registration">
                <NavLink to="/" exact={true} activeClassName={classes.active}>
                    <span>Registration</span>
                </NavLink>
            </li>
        );
    }

    if (props.showPlanInformation) {
        showNavigation = true;
        planInformationNav = (
            <li className="planInformation">
                <NavLink to="/annuityCalculator" activeClassName={classes.active}>
                    <span>Plan Information</span>
                </NavLink>
            </li>
        );
    }

    if (props.showPlanCompare) {
        showNavigation = true;
        planCompareNav = (
            <li className="planCompare">
                <NavLink to="/planOutput" activeClassName={classes.active}>
                    <span>Portfolio Comparison</span>
                </NavLink>
            </li>
        );
    }

    if (props.showMethodology) {
        showNavigation = true;
        methodologyNav = (
            <li className="Methodology">
                <NavLink to="/Methodology" activeClassName={classes.active}>
                    <span>Methodology</span>
                </NavLink>
            </li>
        );
    }

    if (props.showInstream) {
        showNavigation = true;
        instreamNav = (
            <li className="inStream">
                <NavLink to="/inStream" activeClassName={classes.active}>
                    <span>inStream</span>
                </NavLink>
            </li>
        );
    }

    if (props.showDisclaimer) {
        showNavigation = true;
        disclaimerNav = (
            <li className="Disclaimer">
                <NavLink to="/Disclaimer" activeClassName={classes.active}>
                    <span>Disclaimer</span>
                </NavLink>
            </li>
        );
    }

    if (props.showGlossary) {
        showNavigation = true;
        glossaryNav = (
            <li className="Glossary">
                <NavLink to="/Glossary" activeClassName={classes.active}>
                    <span>Glossary</span>
                </NavLink>
            </li>
        );
    }

    if (props.showRates) {
        showNavigation = true;
        ratesNav = (
            <li className="Rates">
                <NavLink to="/admin/rates" activeClassName={classes.active}>
                    <span>Rates</span>
                </NavLink>
            </li>
        )
    }

    if (props.showProducts) {
        showNavigation = true;
        productsNav = (
            <li className="Products">
                <NavLink to="/admin/products" activeClassName={classes.active}>
                    <span>Products</span>
                </NavLink>
            </li>
        )
    }

    if (props.showIntroduction) {
        showNavigation = true;
        introductionNav = (
            <li className="Introduction">
                <NavLink to="/introduction" activeClassName={classes.active}>
                    <span>Introduction</span>
                </NavLink>
            </li>
        )
    }

    if (props.showBackToIntroductionButton) {
        showNavigation = true;
        backToIntroductionButton = (
            <li className={classes.BackToIntroductionButton}>
                <NavLink className={classes.BackToIntroductionButtonNavLink} to="/introduction">
                    <span>Back to introduction</span>
                </NavLink>
            </li>
        )
    }

    return (
        showNavigation ?
            <div className={classes.Navigation}>
                <ul>
                    {registrationNav}
                    {planInformationNav}
                    {planCompareNav}
                    {methodologyNav}
                    {instreamNav}
                    {disclaimerNav}
                    {glossaryNav}
                    {ratesNav}
                    {productsNav}
                    {introductionNav}
                    {backToIntroductionButton}
                </ul>
            </div> : null
    );
};

export default navigation;


// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js